import { APIExtRoutes } from "@constants";
import { APIResponse } from "@models/core";
import {
  AnalysisFeeCalculatorDTO,
  PortfolioAssignmentValidationRequestDTO,
  PortfolioAssignmentValidationResultDTO,
} from "@models/platform-analysis/entities/steps/fee";
import { APIGatewayService, handleErrorProxy } from "@services/shService";
import { generatePath } from "react-router";

export async function getFeeCalculatorStep(
  platformAnalysisId: string,
): Promise<APIResponse<AnalysisFeeCalculatorDTO>> {
  const response = await APIGatewayService.get<AnalysisFeeCalculatorDTO>(
    generatePath(APIExtRoutes.platformAnalysisFeeCalculator, {
      platformAnalysisId,
    }),
  );
  
  return handleErrorProxy(response);
}

export async function putFeeCalculatorStep(
  platformAnalysisId: string,
  formData: AnalysisFeeCalculatorDTO,
): Promise<APIResponse<string>> {
  const response = await APIGatewayService.put<string>(
    generatePath(APIExtRoutes.platformAnalysisFeeCalculator, {
      platformAnalysisId,
    }),
    formData,
  );
  return handleErrorProxy(response, "Changes have been saved.");
}

export async function checkPortfolioAssignment(
  platformAnalysisId: string,
  data: PortfolioAssignmentValidationRequestDTO,
): Promise<APIResponse<PortfolioAssignmentValidationResultDTO[]>> {
  const response = await APIGatewayService.post<
    PortfolioAssignmentValidationResultDTO[]
  >(
    generatePath(APIExtRoutes.platformAnalysisPortfolioAssignmentValidation, {
      platformAnalysisId,
    }),
    data,
  );

  return handleErrorProxy(response);
}
